// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  GetUserResponse,
  UserQueryParams,
  User as UserItem,
} from "utils/api/client/types/user"

export class User {
  private client: unknown

  /**
   * @ignore
   */
  constructor(client: unknown) {
    this.client = client
  }

  async list(
    query?: UserQueryParams,
    vendorId?: string,
    headers?: unknown
  ): Promise<GetUserResponse> {
    return (this.client as any).fetch(
      vendorId ? `vendor/${vendorId}/users` : `/admin/p_users`,
      {
        query,
        headers,
      }
    )
  }

  create(
    body: any,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<any> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/p_users`, {
        method: "POST",
        headers,
        body,
        query,
      })
    })()
  }

  update(
    id: string,
    body: any,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<any> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/p_users/${id}`, {
        method: "PUT",
        headers,
        body,
        query,
      })
    })()
  }

  retrieve(
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<{ data: UserItem }> {
    return (async () => {
      const { id, ...reset } = queryParams as any
      return await (this.client as any).fetch(`/admin/p_users/${id}`, {
        query: reset,
        headers,
      })
    })()
  }

  delete(id: string, headers?: Record<string, unknown>): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/p_users/${id}`, {
        method: "DELETE",
        headers,
      })
    })()
  }
}
